var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:_vm.styleClass,attrs:{"size":_vm.size,"rounded":_vm.rounded}},[_c('v-img',{attrs:{"size":_vm.iconSize,"src":"/api/v2/media/user-image-not-found.jpg","lazy-src":"/api/v2/media/user-image-not-found.jpg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }